import { ContentBlock } from 'braid-design-system';
import React from 'react';

import { ThankYouHand } from '../ThankYouHand';

export const SuccessHeader = () => (
  <ContentBlock width="large">
    <ThankYouHand />
  </ContentBlock>
);
